<template>
	<v-card flat outlined>
		<v-container fluid class="pb-0">
			<v-row>
				<v-col cols="12" lg="12" class="pb-0 pt-0">
					<v-card flat class="pb-0 pt-0">
						<v-card-text class="pb-0 pt-0">
							<v-row>
								<v-col cols="3" offset="4" class="pb-0 pt-2">
									<v-card-title class="justify-center align-center pa-2 pb-0 pt-0">
										{{ $t('titles.teacherRatings') }}</v-card-title
									>
								</v-col>
								<v-col class="pb-0">
									<v-row class="d-flex justify-end pt-0">
										<v-rating
											empty-icon="fa-regular fa-star"
											full-icon="fa-solid fa-star"
											half-icon="fa-star-half-stroke"
											readonly
											half-increments
											color="ratingStars"
											length="5"
											size="24"
											:value="finalRating"
										></v-rating>
									</v-row>
									<v-row class="d-flex justify-end pt-0 mr-1">
										<span class="">
											<b>{{ finalRating.toFixed(2) }}</b
											>/5 ({{ $t('labels.numberOfRatings') }} {{ numberOfRatings }})
										</span>
									</v-row>
								</v-col>
							</v-row>
							<v-row>
								<v-col class="pt-0">
									<TheTable
										:additional-filters="teacherRatingsTable.additionalFilters"
										:default-sort="teacherRatingsTable.defaultSort"
										:excel="false"
										:fields="teacherRatingsTable.headers"
										:header-selection-key="'teacher-ratings-headers'"
										:height="teacherRatingsTable.height"
										:total-records="teacherRatingsTable.total"
										@headers="selectHeaders"
										@reload="reloadData"
									>
										<tr
											v-for="(item, key) in teacherRatingsTable.items"
											:key="key"
											:class="{ 'cursor-pointer': true }"
										>
											<td v-if="teacherRatingsTable.selectedHeaders.includes('creation_date')">
												{{
													item.creation_date != null
														? item.creation_date.split('-').reverse().join('.')
														: ''
												}}
											</td>
											<td
												v-if="
													teacherRatingsTable.selectedHeaders.includes('planned_course_code')
												"
											>
												{{ item.code }}
											</td>
											<td v-if="teacherRatingsTable.selectedHeaders.includes('course_name')">
												{{ item.name }}
											</td>
											<td v-if="teacherRatingsTable.selectedHeaders.includes('registration')">
												{{ item.registration }}
											</td>
											<td
												v-if="teacherRatingsTable.selectedHeaders.includes('amount_of_ratings')"
											>
												{{ item.amount_of_ratings }}
											</td>
											<td v-if="teacherRatingsTable.selectedHeaders.includes('rating')">
												{{ parseFloat(item.teacher_rating).toFixed(2) }}
											</td>
										</tr>
									</TheTable>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'TeacherRatings',
	components: { TheTable },
	props: {
		teacherId: [String, Number],
	},
	data: function () {
		return {
			teacherRatingsTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.date'),
						value: 'creation_date',
						type: '',
						sortable: true,
						allowFilter: true,
					},
					{
						text: this.$t('fields.course'),
						value: 'planned_course_code',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.courseName'),
						value: 'course_name',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.registration'),
						value: 'registration',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.amountOfRatings'),
						value: 'amount_of_ratings',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.rating'),
						value: 'rating',
						type: '',
						sortable: false,
						allowFilter: true,
					},
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'survey_teachers.id',
					descending: true,
				},
			},
			finalRating: 0,
			numberOfRatings: 0,
		};
	},
	methods: {
		selectHeaders(headers) {
			this.teacherRatingsTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.teacherRatingsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'teachers-ratings/' + this.teacherId,
				request,
				(data, success) => {
					if (success) {
						vm.teacherRatingsTable.items = data.items;
						vm.teacherRatingsTable.total = data.total;
						vm.finalRating = data.finalRating;
						vm.numberOfRatings = data.numberOfRatings;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.teacherRatingsTable.height = window.innerHeight - 310 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
